var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"inline-block relative w-5 h-5 align-middle lg:w-4 lg:h-4",attrs:{"fill":"currentColor"}},[_c('use',{attrs:{"xlink:href":require('@/assets/icons/editor-icon-sprite.svg') + "#" + _vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }